import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { adminStripeBillingQueryKey } from "@/admin/data/useAdminStripeBilling";
import api from "@/common/utils/api";
import { AdminPatchOrgType } from "@reflag/shared/adminAPI";
import { ErrorResponse } from "@reflag/shared/api";
import { Org } from "@reflag/shared/organizationAPI";

export function useAdminOrgPatchMutation(orgId: string) {
  const queryClient = useQueryClient();

  return useMutation<
    Org,
    AxiosError<ErrorResponse>,
    AdminPatchOrgType,
    AdminPatchOrgType
  >({
    mutationKey: ["admin", "org", orgId],
    mutationFn: (body) =>
      api
        .patch<"/admin/:orgId">(`/admin/${orgId}`, body)
        .then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["orgs"],
      });
      queryClient.invalidateQueries({
        queryKey: adminStripeBillingQueryKey(orgId),
      });
    },
  });
}
